import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, reactive, ref } from 'vue';
import SamlSettingCard from './SamlSettingCard.vue';
import SamlSettingPageDemo from './SamlSettingPageDemo.vue';
import { useCompanyFeatureComposable } from '@/composables/useCompanyFeatures';
import type { GetSamlConnectionsResponse } from '@/interfaces/api/general/saml';
import { readAssertedCompany } from '@/store/main/getters';
import store from '@/store';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import {
  dispatchCheckApiError,
  dispatchGetCompanySAMLSetting,
} from '@/store/main/actionsMain';
import { AxiosError } from 'axios';
import { ApiErrorResponse } from '@/interfaces/api/general/errorResponses';


export default /*#__PURE__*/_defineComponent({
  __name: 'SamlSettingPage',
  setup(__props) {

const m = defineMessages({
  consultTitle: '設定変更のご相談',
  consultDescription:
    'SAML認証の設定変更をご希望の場合は、お問い合わせフォームよりご連絡ください。',
  consultLink: 'SAML認証設定変更の依頼',
  noSettingTitle: 'SAML認証は未設定です',
  noSettingDescription1: '現在、SAML認証は設定されていません。',
  noSettingDescription2:
    '設定をご希望の場合は、下記のお問い合わせフォームよりご連絡ください。',
});

const samlSettingList = ref<GetSamlConnectionsResponse>([]);
const { isFeatureActive, COMPANY_FEATURES } = useCompanyFeatureComposable();
const company = reactive({ ...readAssertedCompany(store) });
const isManageSAMLAuthenticationActive = computed(() =>
  isFeatureActive(COMPANY_FEATURES.MANAGE_SAML_AUTHENTICATION)
);

onMounted(async () => {
  //設定が無効の場合は読み込まない
  if (!isManageSAMLAuthenticationActive.value) {
    return;
  }

  try {
    const response = await dispatchGetCompanySAMLSetting(store, {
      companyId: company.uuid,
    });

    if (!response || !response.data) {
      return;
    }

    for (const setting of response.data) {
      samlSettingList.value.push(setting);
    }
  } catch (error) {
    dispatchCheckApiError(store, error as AxiosError<ApiErrorResponse>);
  }
});

return { __sfc: true,m, samlSettingList, isFeatureActive, COMPANY_FEATURES, company, isManageSAMLAuthenticationActive, SamlSettingCard, SamlSettingPageDemo, sharedMessages }
}

})